<template>
    <div class="modal-content fm-modal-folder">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('filemanager.modal.newFolder.title') }}</h5>
            <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="fm-folder-name">{{ $t('filemanager.modal.newFolder.fieldName') }}</label>
                <input type="text" class="form-control" id="fm-folder-name"
                       v-focus
                       v-bind:class="{'is-invalid': directoryExist}"
                       v-model="directoryName"
                       v-on:keyup="validateDirName">
                <div class="feedback" v-show="checkSpecialChar">
                    {{ $t('filemanager.modal.newFolder.checkChar') }}
                </div>            
                <div class="invalid-feedback" v-show="directoryExist">
                    {{ $t('filemanager.modal.newFolder.fieldFeedback') }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-info"
                    v-bind:disabled="!submitActive"
                    v-on:click="addFolder">{{ $t('filemanager.btn.submit') }}
            </button>
            <button class="btn btn-light" v-on:click="hideModal">{{ $t('filemanager.btn.cancel') }}</button>
        </div>
    </div>
</template>

<script>
import modal from '../mixins/modal';

export default {
  name: 'NewFolder',
  mixins: [modal],
  data() {
    return {
      // name for new directory
      directoryName: '',
      isLoading: false,

      // directory exist
      directoryExist: false
    };
  },
  computed: {
    /**
     * Submit button - active or no
     * @returns {string|boolean}
     */
    submitActive() {
      return this.directoryName && !this.directoryExist && !this.checkSpecialChar && !this.isLoading;
    },
    checkSpecialChar() {
      var pattern = /[*'":\\|<>/?]/  
      let valid = false;
      if(pattern.test(this.directoryName)) {
        valid = true;
      }
      return valid;
      
    },
    breadcrumb() {
      return this.$store.getters[`${this.activeManager}/breadcrumb`];
    },    
  },
  methods: {
    /**
     * Check the folder name if it exists or not.
     */
    validateDirName() {
      if (this.directoryName) {
        this.directoryExist = this.$store.getters[`${this.activeManager}/directoryExist`](this.directoryName);
      } else {
        this.directoryExist = false;
      }
    },

    /**
     * Create new directory
     */
    addFolder() {
      this.isLoading = true;
      this.$store.dispatch('createDirectory', this.directoryName).then((response) => {
        this.$store.commit('messages/addLoading');
        // if new directory created successfully
        if (response.data.result.status === 'success') {
          this.isLoading = false;
          // close modal window
          this.hideModal();
        }
      }).finally(() => {
        this.$store.commit('messages/subtractLoading');
      });
    },
  },
};
</script>

<style>
  .feedback {
    color: red;
  }
</style>
